import { SET_PERSONAL_DETAILS } from './PersonalDetailsActions';

export const setPersonalDetailsReducer = (state={}, action)=>{
  const { type, field, value, isAddress } = action;
  switch (type){
  case(SET_PERSONAL_DETAILS):{
    if (isAddress){
      if( field === 'pAddressMilitary'){
        const { pAddress } = state;
        const newAddress = {
          ...pAddress,
          ['pAddressCity']:'',
          [field]: value
        }
        return {
          ...state,
          pAddress: newAddress
        }
      }
      const { pAddress } = state;
      const newAddress = {
        ...pAddress,
        [field]: value
      }
      return {
        ...state,
        pAddress: newAddress
      }
    }
    return { ...state,
      [field]: value }
  }
  default:{
    return state
  }
  }
}